import gsap from 'gsap';
import React, { useCallback, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Icon } from '../';
const Wrapper = styled.div `
  --code-arrow-1-x: 0px;
  --code-arrow-1-rotate: 0deg;
  --code-arrow-2-x: 0px;
  --code-arrow-2-opacity: 1;
  --code-line-y: 0px;
  --code-line-scale: 1;
  --code-line-rotate: 0deg;
  --code-line-opacity: 1;
  position: relative;
  display: table;
  svg {
    --icon-color: ${({ theme }) => theme.primary.background};
    path {
      &:nth-child(1) {
        transform-origin: 16.5% 50%;
        transform: translateX(var(--code-arrow-1-x)) rotate(var(--code-arrow-1-rotate)) translateZ(0);
      }
      &:nth-child(3) {
        transform-origin: 50% 50%;
        transform: translateY(var(--code-line-y)) scaleX(var(--code-line-scale)) rotate(var(--code-line-rotate))
          translateZ(0);
        opacity: var(--code-line-opacity);
      }
      &:nth-child(2) {
        transform: translateX(var(--code-arrow-2-x)) translateZ(0);
        opacity: var(--code-arrow-2-opacity);
      }
    }
  }
`;
export const IconCode = ({ className, onDone, running }) => {
    const wrapperRef = useRef(null);
    const triggerDone = useCallback(() => {
        if (onDone) {
            onDone();
        }
    }, [onDone]);
    useEffect(() => {
        if (running) {
            gsap.to(wrapperRef.current, {
                '--code-arrow-1-rotate': '180deg',
                '--code-arrow-1-x': '2px',
                '--code-arrow-2-x': '4px',
                '--code-arrow-2-opacity': 0,
                '--code-line-y': '4px',
                '--code-line-scale': 0.5,
                '--code-line-rotate': '65deg',
                duration: 0.3,
                onComplete: (target) => {
                    gsap.to(target, {
                        duration: 0.6,
                        repeat: 1,
                        keyframes: [
                            {
                                '--code-line-opacity': 0,
                            },
                            {
                                '--code-line-opacity': 1,
                            },
                        ],
                        onComplete: () => {
                            gsap.to(target, {
                                '--code-arrow-1-rotate': '0deg',
                                '--code-arrow-1-x': '0px',
                                '--code-arrow-2-x': '0px',
                                '--code-arrow-2-opacity': 1,
                                '--code-line-y': '0px',
                                '--code-line-scale': 1,
                                '--code-line-rotate': '0deg',
                                duration: 0.3,
                                clearProps: true,
                                onComplete: () => {
                                    triggerDone();
                                },
                            });
                        },
                    });
                },
                onCompleteParams: [wrapperRef.current],
            });
        }
    }, [running]);
    return (React.createElement(Wrapper, { className: className, ref: wrapperRef },
        React.createElement(Icon.Code, null)));
};
//# sourceMappingURL=Code.js.map